import React, { useState } from "react"
import { ReactSVG } from "react-svg"
import * as styles from "./transport-title.module.scss"
import { TransportTitleListFieldsFragment } from "../../../../graphql-types"
import sanitizeHtml from "sanitize-html"
import { useIsMobile } from "../../../hooks"
import RectangularButton from "../rectangular-button/rectangular-button"

type RenderProps = {
  transportTitleData: TransportTitleListFieldsFragment
}

const TransportTitle: React.FC<RenderProps> = ({ transportTitleData }) => {
  const isMobile = useIsMobile()
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const TEXT_MAX_LENGTH: number = isMobile ? 335 : 414
  const sanitizedDescription: string = transportTitleData.description
    ? sanitizeHtml(transportTitleData.description, {
        allowedTags: ["b", "i", "em", "strong", "a", "p"],
      })
    : ""

  const isEllispisNeeded: boolean =
    transportTitleData.description && sanitizeHtml(transportTitleData.description).length > TEXT_MAX_LENGTH
      ? true
      : false

  // Only truncate while collapsed; once expanded the full text is shown.
  const isTruncated: boolean = isEllispisNeeded && !isExpanded

  return (
    <div className={isExpanded ? `${styles.transportTitle} ${styles.expanded}` : styles.transportTitle}>
      <div className={styles.transportTitleLabel}>{transportTitleData.title}</div>
      <div className={styles.transportTitleContent}>
        {transportTitleData.picture && transportTitleData.picture.url ? (
          <div className={styles.transportTitleImageBox}>
            {transportTitleData.picture.format == "svg" ? (
              <ReactSVG
                src={transportTitleData.picture.url}
                beforeInjection={svg => svg.setAttribute("aria-label", transportTitleData.picture.alt || "")}
              />
            ) : (
              <img src={transportTitleData.picture.url} alt={transportTitleData.picture.alt || ""} />
            )}
          </div>
        ) : null}
        <div className={styles.transportTitleDescription}>
          <div
            className={
              isTruncated ? `${styles.truncateContent} ${styles.truncateOverflow}` : `${styles.truncateContent}`
            }
          >
            <p dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />
            {isTruncated ? (
              <button
                type="button"
                className={styles.expandButton}
                aria-expanded={false}
                aria-label={transportTitleData.description}
                onClick={() => setIsExpanded(true)}
              >
                ...
              </button>
            ) : null}
          </div>
          <div className={styles.transportTitleActionButton}>
            {transportTitleData.redirectionUrl ? (
              <RectangularButton
                label={transportTitleData.redirectionLabel}
                redirectUrl={transportTitleData.redirectionUrl}
              ></RectangularButton>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransportTitle
